import React from 'react';

const ColorRoundExclamation = (props) => {
  return(
  <svg className={props.className} width="20px" height="20px" viewBox="0 0 21 21" version="1.1">
    <g id="icon_alert" transform="translate(-2, -2)">
      <path d="M12.5,2.08333333 C6.77083333,2.08333333 2.08333333,6.77083333 2.08333333,12.5 C2.08333333,18.2291667 6.77083333,22.9166667 12.5,22.9166667 C18.2291667,22.9166667 22.9166667,18.2291667 22.9166667,12.5 C22.9166667,6.77083333 18.2291667,2.08333333 12.5,2.08333333 L12.5,2.08333333 Z M12.5,21.875 C7.34375,21.875 3.125,17.65625 3.125,12.5 C3.125,7.34375 7.34375,3.125 12.5,3.125 C17.65625,3.125 21.875,7.34375 21.875,12.5 C21.875,17.65625 17.65625,21.875 12.5,21.875 L12.5,21.875 Z" fill="#EA755F" />
      <path d="M12.5,14.7395833 C12.1875,14.7395833 11.9791667,14.53125 11.9791667,14.21875 L11.9791667,6.25 C11.9791667,5.9375 12.1875,5.72916667 12.5,5.72916667 C12.8125,5.72916667 13.0208333,5.9375 13.0208333,6.25 L13.0208333,14.21875 C13.0208333,14.4791667 12.8125,14.7395833 12.5,14.7395833 L12.5,14.7395833 Z" id="Shape" fill="#EA755F" />
      <path d="M12.5,19.2708333 C12.1875,19.2708333 11.9791667,19.0625 11.9791667,18.75 L11.9791667,16.9270833 C11.9791667,16.6145833 12.1875,16.40625 12.5,16.40625 C12.8125,16.40625 13.0208333,16.6145833 13.0208333,16.9270833 L13.0208333,18.75 C13.0208333,19.0625 12.8125,19.2708333 12.5,19.2708333 L12.5,19.2708333 Z" id="Shape" fill="#EA755F" />
    </g>
  </svg>
  )
};

export default ColorRoundExclamation;



/** WEBPACK FOOTER **
 ** ./shared-components/Svg/ColorRoundExclamation.js
 **/